import "./notification-popup.scss";
import { Dispatch, SetStateAction } from "react";
import { NotificationResponse, NotificationType, useSetStatusFlagOfNotificationMutation } from "pages/authentication/userService";
import Notification from "./Notification";
interface NotsProps {
  notifications: NotificationResponse[] | undefined;
  setNotifications: Dispatch<SetStateAction<NotificationResponse[] | undefined>>;
}

export default function NotificationPopup({ notifications, setNotifications }: NotsProps) {
  const [updateNotificationStatus] = useSetStatusFlagOfNotificationMutation();

  const handleRemoveViewedNotification = (id: string) => {
    if (!notifications) return;

    const clickedNotification = notifications.find((n) => n.id === id);
    const isClickedEsign = clickedNotification?.notificationType?.toLowerCase() === NotificationType.Esign.toLowerCase();

    const esignNotifications = notifications.filter((n) => n.notificationType?.toLowerCase() === NotificationType.Esign.toLowerCase());

    const idsToRemove = isClickedEsign
      ? esignNotifications.map((n) => n.id) // Remove all Esign notifications
      : [...esignNotifications.map((n) => n.id), id]; // Remove clicked + all Esign

    // Update status for all notifications being removed
    for (const notificationId of idsToRemove) {
      void updateNotificationStatus(notificationId);
    }
    // Remove selected notifications
    setNotifications((prev) => prev?.filter((notification) => !idsToRemove.includes(notification.id)));
  };

  return (
    <div className="notify-popup-container">
      <div className="notifiy-scroll">
        {notifications?.map((data, index) => (
          <Notification
            id={data.id}
            userId={data.userId}
            nhDealApplicationId={data.nhDealApplicationId}
            title={data.title}
            text={data.text}
            link={data.link}
            createdOn={data.createdOn}
            key={data.id || index}
            notificationType={data.notificationType}
            onRemoveViewedNotification={handleRemoveViewedNotification}
          />
        ))}
      </div>
    </div>
  );
}
